import React, { useState, Fragment } from 'react'
import PropTypes from 'prop-types'

import StepSeparator from 'loyal-design-system/assets/images/step-separator.png'
import StepSeparatorActive from 'loyal-design-system/assets/images/step-separator-active.png'

import RequestCardStage from './RequestCardStage'
import Address from './Address/Address'
import Credit from './Credit/Credit'
import Success from './Success/Success'

const RequestCard = ({ success, initialCredit, totalPoints, initialMiles, address, handleInitialCredit, handleInitialMiles, handleAddress, handlePointsConversion, accessToken, balance, transactionId }) => {
  const [ step, setStep ] = useState(1)
  const [ stepOnMode, setStepOnMode ] = useState('add')

  const handleStep = (step) => {
    setStep(step)
  }

  const handleStepOnMode = (mode) => {
    setStepOnMode(mode)
  }

  return (
    <div>
      <div className='col-12 d-flex mt-2 flex-column flex-md-row'>
        <div className='col-12 col-md-6'>
          <h2>{success
            ? 'Solicitação concluída'
            : 'Peça já seu cartão'}
          </h2>
          <p className='my-2 col-12 p-0'>
            {success
              ? 'Acompanhe todos os detalhes da sua solicitação'
              : 'Solicite seu novo Cartão Pré-pago Like Mais em poucos passos'}
          </p>
        </div>
        <div className='col-12 col-md-6'>
          <div className='col-12 col-md-12 txt-center my-3 px-0 d-flex justify-content-center align-items-center'>
            <RequestCardStage icon={'icon_truck'} text={'Endereço de entrega'} completed={(step >= 1 || success)} />
            <img src={(step === 2 || success) ? StepSeparatorActive : StepSeparator} />
            <RequestCardStage icon={'icon_pay'} text={'Crédito inicial'} completed={(step >= 2 || success)} />
            <img src={(step === 3 || success) ? StepSeparatorActive : StepSeparator} />
            <RequestCardStage icon={'icon_check'} text={'Solicitação concluída'} completed={(step >= 3 || success)} />
          </div>
        </div>
      </div>

      <div>
        {success ? (
          <Success
            address={address}
            totalPoints={totalPoints}
            initialMiles={initialMiles}
            transactionId={transactionId} />
        ) : (
          <Fragment>
            <Address
              handleStep={handleStep}
              handleStepOnMode={handleStepOnMode}
              handleAddress={handleAddress}
              step={step}
              stepOnMode={stepOnMode}
              address={address}
            />
            <Credit
              handleInitialCredit={handleInitialCredit}
              handleInitialMiles={handleInitialMiles}
              handleStep={handleStep}
              initialCredit={initialCredit}
              step={step}
              handlePointsConversion={handlePointsConversion}
              accessToken={accessToken}
              balance={balance} />
          </Fragment>
        )}
      </div>
    </div>
  )
}

RequestCard.propTypes = {
  success: PropTypes.bool,
  initialCredit: PropTypes.any,
  totalPoints: PropTypes.any,
  initialMiles: PropTypes.any,
  address: PropTypes.object,
  handleInitialCredit: PropTypes.func,
  handleInitialMiles: PropTypes.func,
  handleAddress: PropTypes.func,
  handlePointsConversion: PropTypes.func,
  accessToken: PropTypes.string,
  balance: PropTypes.object,
  transactionId: PropTypes.string
}

export default RequestCard



// WEBPACK FOOTER //
// ./src/features/LikePlus/Tabs/RequestCard/RequestCard.js